import {
  PageSize,
  ACCESS_TOKEN_NAME,
  REFRESH_TOKEN_NAME,
} from "../shared/constant";

const globalUtils = {
  download: (data: any, filename: string) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  /* (['c', 'b', 'a'], ['a', 'b', 'c']) return true */
  areEqualTwoArray: (array1: string[], array2: string[]) => {
    if (array1.length === array2.length) {
      return array1.every((element) => {
        if (array2.includes(element)) return true;
        return false;
      });
    }
    return false;
  },
  checkIsScroll: (data: object[]) => {
    if (data.length <= PageSize.DEFAULT) return false;
    return true;
  },
  joinByCommaWithSpace: (p: string) => {
    // ABC,    Xyz => ABC, Xyz
    const cData = p
      .split(",")
      .map((item: string) => item.trim())
      .join(", ");
    return cData;
  },
  snakeCaseToCapitalize: (word: string) => {
    const cWord = word
      .split("_")
      .map((el) =>
        ["clap", "id"].includes(el.toLowerCase())
          ? el.toUpperCase()
          : el.charAt(0).toUpperCase() + el.slice(1).toLowerCase(),
      )
      .join(" ");
    return cWord;
  },
  eliminateEmptyString: (obj: object) => {
    const result = Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== ""),
    );
    return result;
  },
  /** Intl.NumberFormat; */
  // FIXME not working properly for floating point and 0 value
  commaSeparatedNum: (number: number | undefined | null) => {
    if (number || number === 0)
      return new Intl.NumberFormat("en-IN").format(number);
    return "";
  },
  isPhotoExist: (p: string) => {
    // FIXME <<alert>> change this in production
    if (!p || p.includes("/media/settings.MEDIA_ROOT/profile_pic/avatar.jpg"))
      return false;
    return true;
  },
  isResultsExistInObj: (obj: object) => {
    if ("results" in obj) return true;
    return false;
  },
  removeTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(REFRESH_TOKEN_NAME);
  },
};

export default globalUtils;
